import React from 'react'
import { Route, Redirect } from 'react-router'
import { connect } from 'react-redux'
import * as reducers from '../reducers'



const PrivateRoute = ({ component: Component,  ...rest }) => {

    const {isAuthenticated} = rest;
    return (<Route {...rest} render={(props) => {
        return(
            isAuthenticated ? (
                <Component {...props}/>
            ) : (
                <Redirect to={{
                    pathname: '/login',
                    state: {from: props.location}
                }}/>
            )
        )
    }
    }/>)
}

const mapStateToProps = (state) => ({
  isAuthenticated: reducers.isAuthenticated(state)
})

export default connect(mapStateToProps, null)(PrivateRoute);


// WEBPACK FOOTER //
// ./src/containers/PrivateRoute.js